import { useCallback } from 'react'
import { VersionReportTemplatePageFormModel } from '../../../model/VersionReportTemplatePageFormModel'

export const usePageConfigHandlers = (
  page: VersionReportTemplatePageFormModel,
  onUpdate: (
    pageNumber: number,
    updater: (
      prev: VersionReportTemplatePageFormModel
    ) => VersionReportTemplatePageFormModel
  ) => void
) => {
  const handlePageTitleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onUpdate(page.pageNumber, prev => ({
        ...prev,
        pageTitle: e.target.value,
      }))
    },
    [page.pageNumber, onUpdate]
  )

  return {
    handlePageTitleChange,
  }
}
